<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted () {
    console.log('first')
    this.deviceCheck()
  },
  methods: {
    deviceCheck () {
    // 디바이스 종류 설정
      var pcDevice = 'win16|win32|win64|mac|macintel'
      // 접속한 디바이스 환경
      if (navigator.platform) {
        if (pcDevice.indexOf(navigator.platform.toLowerCase()) < 0) {
          this.$router.push('/mobile')
        } else {
          console.log('pc')
        }
      }
    }
  }
}
</script>

<style>
@import url(http://fonts.googleapis.com/earlyaccess/notosanskr.css);
#app {
  width:100%;
  height:90%;
  font-family: 'Noto Sans KR', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue